/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomDetailTypes {
  STR = 'str',
  LOCATION = 'location',
  BOOL = 'bool',
  RESOURCE_INT = 'resourceInt',
}
